import PageShell from "@/components/founding/PageShell";
import SeoHead from "@/components/seo/SeoHead";
import StaffGallery from "@/components/staff/StaffGallery";

const STAFF_SEO = {
    title: "Meet our Staff | Fire Suppression Retrofit Studio",
    description:
        "Meet the FSRS staff. Tap a face to watch a short intro clip from each teammate.",
    canonical: "/staff",
};

export default function StaffPage() {
    return (
        <PageShell>
            <SeoHead {...STAFF_SEO} />
            <section
                className="relative border-b border-white/10 bg-[color-mix(in_srgb,#7dd3fc_8%,#000)]"
                data-testid="staff-hero"
            >
                <div className="mx-auto max-w-[1400px] px-6 lg:px-10 pt-16 pb-10 lg:pt-24 lg:pb-14">
                    <div className="fsrs-overline mb-4">/&nbsp;THE&nbsp;CREW</div>
                    <h1 className="fsrs-heading text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.02]">
                        MEET OUR <span className="text-red-500">STAFF</span>
                    </h1>
                    <p
                        className="mt-5 max-w-2xl text-slate-300 text-lg leading-relaxed"
                        data-testid="staff-intro"
                    >
                        The people behind Fire Suppression Retrofit Studio. Tap
                        a face to play a short intro clip.
                    </p>
                    <p
                        className="mt-3 max-w-2xl text-slate-400 text-base leading-relaxed"
                        data-testid="staff-disclosure"
                    >
                        Portraits and intro clips are AI-generated.
                    </p>
                </div>
            </section>
            <StaffGallery />
        </PageShell>
    );
}
